"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, IconButton } from "@mui/material";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { usePathname } from "next/navigation";
import { pushGtmEvent } from "../../../../../lib/utils/gtmEventHandler";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
export const ShareTextButton = t0 => {
  const $ = _c(18);
  const {
    digitalProfile,
    btnBorder: t1
  } = t0;
  const btnBorder = t1 === undefined ? true : t1;
  const {
    profileName
  } = digitalProfile;
  const track = useInhomzTrack();
  const text = `${profileName}'s digital profile`;
  const pathname = usePathname();
  const getBaseUrl = _temp;
  let t2;
  if ($[0] !== pathname) {
    t2 = typeof window !== "undefined" ? window.location.href : `${getBaseUrl()}${pathname}`;
    $[0] = pathname;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const shareUrl = t2;
  let t3;
  if ($[2] !== digitalProfile.id || $[3] !== digitalProfile.phoneNumber || $[4] !== digitalProfile.profileId || $[5] !== digitalProfile.profileName || $[6] !== digitalProfile.project_count || $[7] !== profileName || $[8] !== shareUrl || $[9] !== text || $[10] !== track) {
    t3 = async () => {
      const gtmEventData = {
        contractor_id: digitalProfile?.id,
        contractor_name: digitalProfile?.profileName,
        contractor_phone_number: digitalProfile?.phoneNumber,
        contractor_profile_id: digitalProfile?.profileId,
        project_photo_count: digitalProfile?.project_count
      };
      pushGtmEvent({
        event_name: "contractor_profile_page_action_taken",
        event_action: "profile_share_clicked",
        ...gtmEventData
      });
      track(inhomzEvents.contractorProfile.SHARE_CLICKED, {
        contractor_name: profileName,
        placement: "cta"
      });
      if (navigator.share) {
        ;
        try {
          await navigator.share({
            title: "Check this out!",
            text,
            url: shareUrl
          });
        } catch (t4) {
          const error = t4;
          console.log("Error sharing content:", error);
        }
      } else {
        setOpenBottomSheet(true);
      }
    };
    $[2] = digitalProfile.id;
    $[3] = digitalProfile.phoneNumber;
    $[4] = digitalProfile.profileId;
    $[5] = digitalProfile.profileName;
    $[6] = digitalProfile.project_count;
    $[7] = profileName;
    $[8] = shareUrl;
    $[9] = text;
    $[10] = track;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleShare = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ShareOutlinedIcon />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = btnBorder ? "1px solid var(--colorOutlineOutlineVar)" : "none";
  let t6;
  if ($[13] !== t5) {
    t6 = {
      height: "40px",
      width: "100%",
      borderRadius: "30px",
      backgroundColor: "var(--colorSurfaceSurface)",
      border: t5
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleShare || $[16] !== t6) {
    t7 = <div className=""><Button onClick={handleShare} className="!m3-label-large" startIcon={t4} sx={t6}>Share profile</Button></div>;
    $[15] = handleShare;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
function _temp() {
  return typeof window !== "undefined" ? window.location.origin : process.env.NEXT_PUBLIC_SITE_URL || "https://letsmultiply.co.in";
}